import { render, staticRenderFns } from "./DndFormItems.vue?vue&type=template&id=c13b25d8&scoped=true"
import script from "./DndFormItems.vue?vue&type=script&lang=js"
export * from "./DndFormItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13b25d8",
  null
  
)

export default component.exports